import { Link } from "react-router-dom";
import { ArrowUpRight, Boxes } from "lucide-react";

const MERCHANT_LOGOS = ["Amazon", "Shopify", "Walmart", "Target+", "eBay"];

const MerchantStrip = () => (
  <section className="relative">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="rounded-3xl border border-[var(--tt-line)] bg-white p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-start md:items-center gap-4">
          <div className="h-12 w-12 rounded-xl bg-[var(--tt-mint-soft)] text-[var(--tt-green)] grid place-items-center shrink-0">
            <Boxes className="h-6 w-6" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.16em] text-[var(--tt-zam-orange)] font-semibold">
              Are you a marketplace seller?
            </div>
            <h3 className="font-display text-2xl md:text-[28px] font-bold text-[var(--tt-navy)] mt-1 leading-tight">
              We fulfill for {MERCHANT_LOGOS.join(" · ")} sellers.
            </h3>
            <p className="mt-1 text-sm text-[var(--tt-ink-soft)]">
              GS1-compliant WMS · Same-day dispatch · &gt;99% on-time ship rate
            </p>
          </div>
        </div>
        <Link to="/fulfillment" className="btn-primary self-start md:self-center shrink-0">
          See 3PL services <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  </section>
);

export default MerchantStrip;
